import React, { useState, useContext } from 'react';
import DualButtons from 'components/DualButtons';
import cx from 'classnames';
import List from 'components/List';
import ListItem from 'components/List/ListItem';
import Header from 'components/CardShell/Header';
import MultiSelectedSvg from 'images/multiSelected.svg';
import MultiUnselectedSvg from 'images/multiUnselected.svg';
import ShipmentFilterContext from 'routes/Settings/ShipmentFilters/ShipmentFiltersContext';
import Spinner from 'components/Spinner';
import Svg from 'components/Svg';
import styles from './styles.scss';

const CarrierIntegrations = (props) => {
  const {
    carrierIntegrations,
  } = useContext(ShipmentFilterContext);
  const [filteredCarrierIntegrations, setFilteredCarrierIntegrations] = useState(carrierIntegrations.map(ci => ({ ...ci, hidden: false })));

  const handleFilterCarrierStringChange = (filterString) => {
    const newlyFilteredCarrierIntegrations = filteredCarrierIntegrations.map(
      ci => {
        if (!ci.name.toLowerCase().includes(filterString.toLowerCase())) {
          return ({ ...ci, hidden: true });
        }
        return ({ ...ci, hidden: false });
      },
    );
    setFilteredCarrierIntegrations(newlyFilteredCarrierIntegrations);
  };

  CarrierIntegrations.MapToResponse = (carrierIntegration) => ({
    id: carrierIntegration.id,
    carrier_id: carrierIntegration.carrier.id,
  });

  const carrierIntegrationsFormData = props.formData.carrier_integrations || [];

  const handleCarrierIntegrationSelect = (e) => {
    props.updateState({
      carrier_integrations: e.map(i => CarrierIntegrations.MapToResponse(carrierIntegrations[i])),
    });
  };

  const handleSelectAllEventsClick = () => {
    props.updateState({
      carrier_integrations: carrierIntegrations.map(CarrierIntegrations.MapToResponse),
    });
  };

  const handleUnselectAllEventsClick = () => {
    props.updateState({ carrier_integrations: [] });
  };

  const handleSectionChange = (page) => {
    props.gotoPage(page);
  };

  const areAllCarrierSelected = () => carrierIntegrations.length !== 0
    && carrierIntegrationsFormData.length === carrierIntegrations.length
    && carrierIntegrationsFormData.every(x => carrierIntegrations.some(y => x.id === y.id));

  const {
    title,
    pageTabs,
    cancel,
  } = props;

  return (
    <div className={styles.cardSection}>
      {!carrierIntegrations && <Spinner />}
      <div className={styles.cardSectionNav}>
        {pageTabs()}
      </div>
      <div className={styles.cardSectionInner}>
        <Header>{title}</Header>
        <p className={styles.numberSection}>
          Select the carriers you want updates on.<br />
          You can skip this step if you want to be notified about shipments from any carrier.
        </p>
        {carrierIntegrations && (
        <>
          <div className={styles.actionsContainer}>
            {areAllCarrierSelected()
              ? (
                <button
                  type="button"
                  className={cx(styles.action, 'button-outline')}
                  onClick={handleUnselectAllEventsClick}
                >
                  Unselect all
                </button>
              )
              : (
                <button
                  type="button"
                  className={cx(styles.action, 'button-outline')}
                  onClick={handleSelectAllEventsClick}
                >
                  Select all
                </button>
              )}
          </div>
          <div className={styles.filterSearch}>
            <Svg className={styles.filterSearchGlass} name="searchGlass" />
            <input
              className={styles.filterSearchInput}
              type="text"
              onChange={(e) => {
                handleFilterCarrierStringChange(e.target.value);
              }}
              placeholder="Search Carriers"
            />
          </div>
          <List
            className={styles.list}
            isSelectable
            isMultiSelect
            selectedIndexes={carrierIntegrationsFormData.map(carrierIntegration => carrierIntegrations
              .findIndex(x => x.id === carrierIntegration.id))}
            onSelectionChange={handleCarrierIntegrationSelect}
          >
            {filteredCarrierIntegrations.map(carrierIntegration => (
              <ListItem key={carrierIntegration.id} selectedItemClassName={styles.selectedCalculatedEvent} hidden={carrierIntegration.hidden}>
                <div className={styles.listItem}>
                  <span className={styles.listItemTitle}>{carrierIntegration.name}</span>
                  <img alt="" className={styles.carrierLogo} src={carrierIntegration.carrier.logoUrl} />
                  <MultiSelectedSvg className={cx(styles.selectIcon, styles.selectedIcon)} />
                  <MultiUnselectedSvg className={cx(styles.selectIcon, styles.unselectedIcon)} />
                </div>
              </ListItem>
            ))}
          </List>
        </>
        )}
      </div>
      <div className={styles.cardSectionButtons}>
        <DualButtons
          leftFunction={cancel}
          leftText="Cancel"
          rightFunction={() => handleSectionChange(2)}
          rightText="Next"
          theme="rightPink"
        />
      </div>
    </div>
  );
};

export default CarrierIntegrations;
